import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { Ripple } from "@progress/kendo-react-ripple";

type loadingType = "pulsing" | "infinite-spinner" | "converging-spinner";
type loadingSize = "small" | "medium" | "large";
type fillMode = "solid" | "outline" | "flat" | "link";
type Type = "submit" | "button" | "reset";
type themeColor =
  | "primary"
  | "base"
  | "secondary"
  | "tertiary"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "dark"
  | "light"
  | "inverse";

interface ILoadingButtonProps {
  label: string;
  loading?: boolean;
  disabled?: boolean;
  loadingType?: loadingType;
  size?: loadingSize;
  color?: string;
  fillMode?: fillMode;
  type?: Type;
  width?: string;
  style?: React.CSSProperties;
  themeColor?: themeColor;
  className?: string;
  onClick?: () => any;
}

const ButtonWithLoading: React.FC<ILoadingButtonProps> = ({
  label,
  style,
  loading = false,
  disabled = false,
  loadingType = "pulsing",
  size = "small",
  color = "white",
  fillMode = "solid",
  themeColor = "primary",
  type = "button",
  width = "fit-content",
  className = "",
  onClick,
}) => {
  return (
    <Ripple>
      <Button
        type={type}
        fillMode={fillMode}
        style={{ width: width, ...style }}
        themeColor={themeColor}
        disabled={disabled}
        className={className}
        onClick={onClick}
      >
        {!loading ? (
          label
        ) : (
          <Loader style={{ color: color }} size={size} type={loadingType} />
        )}
      </Button>
    </Ripple>
  );
};

export default ButtonWithLoading;
